import { render, staticRenderFns } from "./WhyNew.vue?vue&type=template&id=00c681d8&"
import script from "./WhyNew.vue?vue&type=script&lang=js&"
export * from "./WhyNew.vue?vue&type=script&lang=js&"
import style0 from "./WhyNew.vue?vue&type=style&index=0&id=00c681d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIDiacritics: require('/opt/build/repo/components/UI/Diacritics.vue').default})
